import { Alert, AlertTitle, Box, Checkbox, Container, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Pagination, Select, Typography } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useNavigationType, useSearchParams } from 'react-router-dom';
import Loader from "../CommonParts/Loader";
import { useAppContext } from "../../Contexts/AppContext";
import GridDisplay from './Parts/GridDisplay';

export default function SearchResultList() {
    const { Actions, Reducer, LanguageResponsiveMessages, ApiErrorMessages } = useAppContext();

    const [searchParams] = useSearchParams();
    const type = useNavigationType();
    const [allSearchResultItems, setAllSearchResultItems] = useState([]);
    const [displaySearchResultList, setDisplaySearchResultList] = useState([]);
    const [isTimeout, setIsTimeout] = useState(false);
    const ref = useRef(searchParams.get("q"));

    const itemsPerPage = 12;
    const maximumPages = Math.ceil(allSearchResultItems.length / itemsPerPage);

    useEffect(() => {
        Actions.searchResultListFetch({ Keyword: searchParams.get("q") });
        if (ref.current !== searchParams.get("q")) {
            Actions.setSearchResultListHistory(1, []);
        }
        ref.current = searchParams.get("q");
        return () => {
            Actions.searchResultListFetching(false, false);
        }
    }, [searchParams]);

    useEffect(() => {
        if (type !== "POP") {
            Actions.setSearchResultListHistory(1, []);
            setAllSearchResultItems(Reducer.searchResultList);
            setDisplaySearchResultList(Reducer.searchResultList.slice(0, itemsPerPage));
        } else {
            const newDisplaySearchResultList = filterList(Reducer.searchResultListHistory.conditions);

            setAllSearchResultItems(newDisplaySearchResultList);
            setDisplaySearchResultList(
                newDisplaySearchResultList.slice(
                    ((Reducer.searchResultListHistory.currentPage - 1) * itemsPerPage), Reducer.searchResultListHistory.currentPage * itemsPerPage
                ));
        }
    }, [Reducer.searchResultList]);

    let artCount = 0;
    let artistCount = 0;
    let eventCount = 0;
    Reducer.searchResultList.forEach(element => {
        if (element.IsArt) {
            artCount++
        } else if (element.IsArtist) {
            artistCount++
        } else if (element.IsEvent) {
            eventCount++
        }
    });

    const commonLabel = LanguageResponsiveMessages.commonLabel;
    const filteringConditions = [
        { key: 1, value: 1, text: commonLabel.art },
        { key: 2, value: 2, text: commonLabel.artist },
        { key: 3, value: 3, text: commonLabel.event },
    ];

    function onConditionsChange(evn) {
        const newDisplaySearchResultList = filterList(evn.target.value);

        Actions.setSearchResultListHistory(1, evn.target.value);
        setAllSearchResultItems(newDisplaySearchResultList);
        setDisplaySearchResultList(newDisplaySearchResultList.slice(0, itemsPerPage));
    }

    function onPageChange(evn, index) {
        Actions.setSearchResultListHistory(index);
        setDisplaySearchResultList(allSearchResultItems.slice(((index - 1) * itemsPerPage), index * itemsPerPage));
    }

    function renderConditionValue(item) {
        switch (item) {
            case commonLabel.art:
                return item + "(" + artCount + ")";

            case commonLabel.artist:
                return item + "(" + artistCount + ")";

            case commonLabel.event:
                return item + "(" + eventCount + ")";

            default:
                return item + "(0)";
        }
    }

    function filterList(selectCondition) {
        const condtionString = selectCondition.join(',');
        let newDisplaySearchResultList = [];

        if (condtionString.includes(commonLabel.art)) {
            newDisplaySearchResultList = newDisplaySearchResultList.concat(Reducer.searchResultList.filter(x => x.IsArt));
        }
        if (condtionString.includes(commonLabel.artist)) {
            newDisplaySearchResultList = newDisplaySearchResultList.concat(Reducer.searchResultList.filter(x => x.IsArtist));
        }
        if (condtionString.includes(commonLabel.event)) {
            newDisplaySearchResultList = newDisplaySearchResultList.concat(Reducer.searchResultList.filter(x => x.IsEvent));
        }
        if (condtionString == "") {
            newDisplaySearchResultList = Reducer.searchResultList;
        }
        return newDisplaySearchResultList;
    }

    const errorMessage =
        Reducer.searchResultListFetch.loadingError
            ? <Alert severity="error" sx={{ mt: 4 }}>
                <AlertTitle>Error</AlertTitle>
                {ApiErrorMessages.apiMessage(Reducer.searchResultListFetch.statusCode, "Reducer.searchResultListFetch")}
            </Alert>
            : null;

    // ローディング表示
    useEffect(() => {
        setTimeout(() => {
            if (Reducer.searchResultListFetch.loading) {
                setIsTimeout(true);
            } else {
                setIsTimeout(false)
            }
        }, 3000);
    }, [Reducer.searchResultListFetch.loading]);

    return (
        <>
            <Container maxWidth="lg">
                <Loader open={Reducer.searchResultListFetch.loading && isTimeout} />
                {errorMessage}
                <Box component="div" className='titleStyle'>
                    <Typography variant="h3" mb={2}>
                        Search Results For ‘{searchParams.get("q")}’
                    </Typography>

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <FormControl sx={{ m: 1, minWidth: 200 }}>
                            <InputLabel>{commonLabel.filters}</InputLabel>
                            <Select
                                multiple
                                value={Reducer.searchResultListHistory.conditions}
                                onChange={onConditionsChange}
                                renderValue={selected => {
                                    const renderValue = selected.map(item => renderConditionValue(item));
                                    return renderValue.join(', ');
                                }}
                                input={<OutlinedInput label={commonLabel.filters} />}
                            >
                                {filteringConditions.map(item => {
                                    const renderValue = renderConditionValue(item.text);
                                    return (
                                        <MenuItem key={item.key} value={item.text}>
                                            <Checkbox checked={Reducer.searchResultListHistory.conditions.indexOf(item.text) > -1} />
                                            <ListItemText primary={renderValue} />
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
                    </div>

                    {Reducer.searchResultListFetch.loading
                        ? null
                        : displaySearchResultList.length === 0
                            ? <Typography variant="body1">
                                {LanguageResponsiveMessages.contentNotFound}
                            </Typography >
                            : <>
                                <GridDisplay mcaList={displaySearchResultList} />

                                <div style={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}>
                                    <Pagination
                                        count={maximumPages}
                                        size="large"
                                        page={Reducer.searchResultListHistory.currentPage}
                                        onChange={onPageChange}
                                    />
                                </div>
                            </>
                    }
                </Box>
            </Container>
        </>
    );
}
